<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Indicadores — Produtividade
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Em
        strong  Indicadores → Produtividade
        |  você consulta a evolução mensal da média geral e da pontuação por fiscal.

      h5.h5 1. Abrir o hub
      ol
        li No menu lateral, abra
          strong  Indicadores
          | .
        li Clique em
          strong  Produtividade
          | .
      figure.manual-figure
        img(:src="imgHub" alt="Hub de indicadores de Produtividade")

      h5.h5 2. Média geral
      ol
        li Abra o card
          strong  Média geral
          | .
        li Em
          strong  Filtrar
          | , informe
          strong  mês início
          |  e
          strong  mês fim
          | .
        li Clique no ícone de
          strong  funil
          |  para gerar o gráfico/tabela da evolução.
        li Use a
          strong  impressora
          |  para imprimir, se houver.
      figure.manual-figure
        img(:src="imgReport" alt="Indicador Média geral de produtividade")
      p Permissão:
        strong  Indicadores → Produtividade → Gerais
        | .

      h5.h5 3. Pontuação por fiscal
      ol
        li Abra o card
          strong  Pontuação por fiscal
          | .
        li Filtre pelo período (mês início/fim) e, quando houver, pelo fiscal.
        li Aplique o funil e acompanhe a evolução mensal da média daquele fiscal.
      p Permissão:
        strong  Indicadores → Produtividade → Resumos
        | .

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgHub: require("@/assets/manuais/32-indicadores-produtividade-hub.png"),
      imgReport: require("@/assets/manuais/32a-indicadores-produtividade-media-geral.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px
</style>
